import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { NFT_SUB_GRAPH_URL } from '../constants/service'

class Api {
  private service: AxiosInstance

  constructor() {
    this.service = axios.create({ baseURL: NFT_SUB_GRAPH_URL })
    this.service.interceptors.response.use(this.handleSuccess, this.handleError)
  }

  private handleSuccess = (response: AxiosResponse) => {
    return response.data
  }

  private handleError = (error: any) => {
    console.log(error)
    return Promise.reject({
      ...error,
      ...error.response,
      status: error.status
    })
  }

  private apiGateway = (apiCall: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await apiCall()
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }

  get = (url: string, headers?: any): any => {
    return this.apiGateway(() => {
      return this.service.get(url, headers)
    })
  }

  post = (url: string, body?: any, headers?: any): any => {
    return this.apiGateway(() => {
      return this.service.post(url, body, headers)
    })
  }

  put = (url: string, body: any): any => {
    return this.apiGateway(() => {
      return this.service.put(url, body)
    })
  }

  delete = (url: string, body: any = {}): any => {
    return this.apiGateway(() => {
      return Promise.resolve(this.service.delete(url, body))
    })
  }
}

export default new Api()
